import { render, staticRenderFns } from "./Statistics_Main.vue?vue&type=template&id=3a4980f1&scoped=true&"
import script from "./Statistics_Main.vue?vue&type=script&lang=js&"
export * from "./Statistics_Main.vue?vue&type=script&lang=js&"
import style0 from "./Statistics_Main.vue?vue&type=style&index=0&id=3a4980f1&lang=scss&%2C=true&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4980f1",
  null
  
)

export default component.exports